import React, { useEffect } from 'react'
import '../css/MyWorks.css'
import WorkContainer from './WorkContainer'
import spotify from '../images/spotify.png'
import amazon from '../images/amazon.png'
import kc from '../images/kc.png'
import construction from '../images/construction site.png'
import dovetail from '../images/Dovetail.png'
import gsap from 'gsap/gsap-core'
import { Bounce } from 'gsap/gsap-core'

function MyWorks({ setPathName }) {
    setPathName(window.location.pathname)
    useEffect(() => {
        gsap.from('.works-container h1', { y: -200, duration: 1.2, ease: Bounce.easeOut, opacity: 0 })
    }, [])
    return (
        <div className='works-container'>
            <h1>My Works</h1>
            <div className='single-work'>
                <WorkContainer
                    className='work5'
                    workImage={dovetail}
                    workHeading={'Dovetail - A chatting app'}
                    gitLink={null}
                    webLink='https://dovetail-elan.herokuapp.com/' />
                <WorkContainer
                    className='work4'
                    workImage={construction}
                    workHeading={'Construction Site'}
                    gitLink='https://github.com/ShakthiGanesh/Daksh2K21' />
                <WorkContainer
                    className='work1'
                    workImage={spotify}
                    workHeading='Spotify-clone'
                    gitLink='https://github.com/ShakthiGanesh/spotify-clone'
                    webLink={null} />
                <WorkContainer
                    className='work2'
                    workImage={amazon}
                    workHeading='Amazon-clone(Desktop app)'
                    gitLink='https://github.com/ShakthiGanesh/Amazon-Clone'
                    webLink='https://clone-636d0.web.app/' />
                <WorkContainer
                    className='work3'
                    workImage={kc}
                    workHeading={'Simple Restaurant app'}
                    gitLink='https://github.com/ShakthiGanesh/Restaurant---SimpleUI'
                    webLink='https://restaurant-reactjsui.herokuapp.com/' />

            </div>
        </div>
    )
}

export default MyWorks
